module.exports = import("https://cdn.esm.sh/react-leaflet/hooks");;